import React from "react";
import { useNavigate } from "react-router-dom";
import fallbackImage from "../assets/images/service.jpg";

function ServiceCard({ service }) {
  const navigate = useNavigate();
  const raw = service.images?.[0];
  const image = raw && raw.startsWith("http") ? raw : fallbackImage;
  const duration = service.duration
    ? `${service.duration} hr${service.duration !== 1 ? "s" : ""}`
    : null;

  return (
    <div className="flex flex-col rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-sm">
      {/* Image */}
      <div className="relative">
        <img
          src={image}
          alt={service.title}
          className="w-full h-48 object-cover"
        />
        <div className="absolute bottom-3 left-3 flex gap-2">
          {duration && (
            <span className="flex items-center gap-1 bg-black/50 text-white text-xs font-manrope-medium px-2 py-1 rounded-full backdrop-blur-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                className="w-3 h-3"
              >
                <circle cx="12" cy="12" r="10" />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 6v6l4 2"
                />
              </svg>
              {duration}
            </span>
          )}
          {service.discountLabel && (
            <span className="flex items-center gap-1 bg-black/50 text-white text-xs font-manrope-medium px-2 py-1 rounded-full backdrop-blur-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                className="w-3 h-3"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 14.25l6-6m0 0l.75.75M15 8.25l-.75-.75M7.5 21L3 16.5m18 0L16.5 21M3 7.5L7.5 3m9 0L21 7.5"
                />
              </svg>
              {service.discountLabel}
            </span>
          )}
        </div>
      </div>

      {/* Body */}
      <div className="p-4 flex flex-col gap-3">
        <div className="flex items-center justify-between">
          <p className="font-manrope-medium text-[18px] text-black leading-snug flex-1 mr-3">
            {service.title}
          </p>
          <p className="font-manrope-bold text-[26px] text-black flex-shrink-0">
            ${service.price}
          </p>
        </div>
        {service.description && (
          <p className="font-manrope-regular text-xs text-secondary line-clamp-2">
            {service.description}
          </p>
        )}
        <div className="flex items-center justify-between gap-4">
          <button
            onClick={() => navigate(`/services/${service.id}/booking`)}
            className="flex items-center gap-2 bg-primary text-white font-manrope-semibold text-base flex-1 py-2 rounded-[12px] hover:opacity-90 transition-opacity justify-center"
          >
            View details
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

export default ServiceCard;
